import { AfterContentInit, Directive, Inject, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ICommonFilterActionCreator } from "../../redux/actions.interface";
import { GenericActions } from "../../redux/generic-actions";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { TOGGLE_FILTER_STATE_PROP } from "./state-props";

@Directive({
    selector: "[common-toggle-filter-action-creators]",
    exportAs: "CommonToggleFilterActionsDirective",
})
export class CommonToggleFilterActionsDirective implements AfterContentInit, OnDestroy {
    @Input("toggleFilterStateProp") public stateProp: string;
    @Input() public listActions: ICommonFilterActionCreator<boolean | null>;

    public filters: any[] = [];
    private state$: Subscription;

    constructor(private ngRedux: ImmutableRedux<any>,
                @Inject(TOGGLE_FILTER_STATE_PROP) public rootProp) {
    }

    public ngAfterContentInit() {
        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            this.filters = state.filters;
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public toggle(index, fieldToFilter, state) {
        if (!state) { // this means to reset to initial state
            this.ngRedux.dispatchFactory(GenericActions.TOGGLE_SELECT, this.rootProp, this.stateProp, null);
            this.listActions.filter(fieldToFilter, null);
            return;
        }

        const payload = index;
        this.ngRedux.dispatchFactory(GenericActions.TOGGLE_SELECT, this.rootProp, this.stateProp, payload);
        this.listActions.filter(fieldToFilter, this.toggledFilterValue(index));
    }

    public toggleButtonGroup(index) {
        this.ngRedux.dispatchFactory(GenericActions.TOGGLE_SELECT, this.rootProp, this.stateProp, index);
    }

    public reset() {
        this.ngRedux.dispatchFactory(GenericActions.STATE_RESET, this.rootProp, this.stateProp);
    }

    public toggledFilterValue(index) {
        const filter = this.filters[index];
        if (filter) { return filter.value; }
        return null;
    }
}
